import { ForwardedRef, forwardRef, useEffect, useRef, useState } from "react";
import Certificate from "../../Certificate/Certificate";
import './CertificationsSlide.css';
import TextSplit from "../../TextSplit/TextSplit";
import Box from "@mui/material/Box";
import { Grid } from "@mui/material";
import { LazyLoadImage } from "react-lazy-load-image-component";

const Certifications = forwardRef((_, ref: ForwardedRef<HTMLDivElement>) => {

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            observer.disconnect(); // Stop observing after loading
          }
        });
      },
      {
        threshold: 0.1 // Adjust as needed
      }
    );

    return () => observer.disconnect();
  }, []);

  return (
    <Box className="content-slide" id="certifications" ref={ref}>
      <Grid container gap={3} className="title-container" id="certifications">
        <Grid item>
          <TextSplit className="slide-h2" id="certifications-h-0" 
            sx={{ fontSize: { xs: '46px', sm: '57px', md: '69px', lg: '80px' } }}
          >
            Certifications
          </TextSplit>
        </Grid>
      </Grid>

      {/* Moved cert-logo-container inside content-container */}
      <Box className="content-container" id="certifications">
        <Box className="cert-logo-container">
          <LazyLoadImage src="img/certifications/dnv_new.png" />
          <LazyLoadImage src="img/certifications/CGP-Logo_1-300x300.png" />
        </Box>

        <Box className="certifications-container">
          <Certificate name="ISO 9001:2015" id="iso-9001-2015" certified={true} pdf="Billet-AS9100" />
          <Certificate name="AS 9100D" id="as-9100d" certified={true} pdf="Billet-AS9100" />
          <Certificate name="ISO 13485" id="iso-13485" certified={false} pdf="" />
          <Certificate name="Controlled Goods" id="cg" certified={true} pdf="Billet-CG" />
        </Box>
      </Box>
    </Box>

  );
});

export default Certifications;
